import type { ImplementationData } from '@/UI/Website/WidgetSettings.page';

export const WIDGET_SCRIPT_URL = 'https://bubble.quickchat.ai/chat.js';

// Deep-link param: `/website?tab=install&install_method=<key>` auto-opens that method's sheet.
export const INSTALL_METHOD_QUERY_PARAM = 'install_method';

export const DOCS_WEBSITE_URL = 'https://docs.quickchat.ai/channels/website/';
export const DOCS_WORDPRESS_URL = 'https://docs.quickchat.ai/channels/wordpress/';
export const DOCS_SHOPIFY_URL = 'https://docs.quickchat.ai/channels/shopify/';
export const WORDPRESS_PLUGIN_URL = 'https://wordpress.org/plugins/quickchat-ai-agent/';

const LOADER = `(function(e,a,d,i,c,t=a.createElement(d)){e[c]=e[c]||function(){(e[c].q=e[c].q||[]).push(arguments)},t.src=i,t.async=1,a.body.insertAdjacentElement("beforeend",t)})(window,document,"script","${WIDGET_SCRIPT_URL}","_quickchat");`;

export function createWidgetSnippet(scenarioId: ImplementationData['scenario_id']): string {
  return `<script>
  ${LOADER}
  _quickchat("init", "${scenarioId}");
</script>`;
}

export function createEmbedSnippet(scenarioId: ImplementationData['scenario_id']): string {
  return `<div id="quickchat-embedded" style="height:600px;overflow:hidden;"></div>
<script>
  ${LOADER}
  _quickchat("containerId", "quickchat-embedded");
  _quickchat("init", "${scenarioId}");
</script>`;
}

export function createShopifyWidgetSnippet(scenarioId: ImplementationData['scenario_id']): string {
  return `<script>
  window.__quickchat_shopify_cart_token = {{ cart.token | json }};
  window.__quickchat_shopify_country = {{ localization.country.iso_code | json }};
  window.__quickchat_shopify_language = {{ localization.language.iso_code | json }};
</script>
<script>
  ${LOADER}
  (function () {
    var params = {};
    var rendered = function (v) { return v && String(v).indexOf("{{") === -1; };
    if (rendered(window.__quickchat_shopify_cart_token)) params.shopify_cart_token = window.__quickchat_shopify_cart_token;
    if (rendered(window.__quickchat_shopify_country)) params.shopify_country = window.__quickchat_shopify_country;
    if (rendered(window.__quickchat_shopify_language)) params.shopify_language = window.__quickchat_shopify_language;
    if (Object.keys(params).length > 0) _quickchat("custom_params", params);
  })();
  _quickchat("init", "${scenarioId}");
</script>`;
}
